import React from "react";
import styles from "./ChatBox.module.css";
import InputQuestion from "./components/InputQuestion/InputQuestion";
import RadioQuestion from "./components/RadioQuestion/RadioQuestion";
import DateQuestion from "./components/DateQuestion/DateQuestion";
import toast, { Toaster } from "react-hot-toast";
import PhotoQuestion from "./components/PhotoQuestion/PhotoQuestion";
import LoadingOverlay from "react-loading-overlay";
import axios from "axios";
import { questions } from "./questions";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";

// base url
const baseUrl = process.env.REACT_APP_API_URL;

const ChatBox = ({ setProfile, profileData }) => {
  //1. states
  const [chatHistory, setChatHistory] = React.useState(
    localStorage.getItem("chatHistory") === null
      ? []
      : JSON.parse(localStorage.getItem("chatHistory"))
  );

  const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const [isOtpVerified, setIsOtpVerified] = React.useState(
    localStorage.getItem("isOtpVerified") ? true : false
  );
  const [isLoginTokenSent, setIsLoginTokenSent] = React.useState(
    localStorage.getItem("isLoginTokenSent") ? true : false
  );
  const [isPersonalLoginTokenSent, setIsPersonalLoginTokenSent] =
    React.useState(
      localStorage.getItem("isPersonalLoginTokenSent") ? true : false
    );
  const [isParentLoginTokenSent, setIsParentLoginTokenSent] = React.useState(
    localStorage.getItem("isParentLoginTokenSent") ? true : false
  );
  const [isImageVerified, setIsImageVerified] = React.useState(
    localStorage.getItem("isImageVerified") ? true : false
  );
  const [isBasicInfoVerified, setIsBasicInfoVerified] = React.useState(
    localStorage.getItem("isBasicInfoVerified") ? true : false
  );
  const [isLoggedIn, setIsLoggedIn] = React.useState(
    localStorage.getItem("token") !== null ? true : false
  );
  const [stagePercentage, setStagePercentage] = React.useState(0);
  //2. use effects
  React.useEffect(() => {
    if (localStorage.getItem("token") !== null) {
      // if loggedin
      hanldleGetProfile();
    }
  }, []);
  React.useEffect(() => {
    let chatHistory = localStorage.getItem("chatHistory");
    if (chatHistory && chatHistory.length > 0) {
      chatHistory = JSON.parse(chatHistory);
      if (!(chatHistory && chatHistory.length > 0)) return;

      const lastQuestionName = chatHistory[chatHistory.length - 1].name;
      let lastQuestionIndex = questions.findIndex(
        (ques) => ques.name === lastQuestionName
      );
      if (lastQuestionIndex !== -1) {
        setCurrentQuestionIndex(lastQuestionIndex + 1);
      } else {
        setCurrentQuestionIndex(0);
      }
    }
  }, [isLoggedIn]);

  React.useEffect(() => {
    if (isOtpVerified) setCurrentQuestionIndex(9);
  }, [isOtpVerified]);
  React.useEffect(() => {
    if (isLoginTokenSent) setCurrentQuestionIndex(1);
  }, [isLoginTokenSent]);

  React.useEffect(() => {
    if (isBasicInfoVerified) setCurrentQuestionIndex(questions.length - 1);
  }, [isBasicInfoVerified]);
  React.useEffect(() => {
    if (isImageVerified) {
      setCurrentQuestionIndex(questions.length - 1);
    }
  }, [isImageVerified]);
  React.useEffect(() => {
    const chatWindow = document.getElementById("chat-window");
    var xH = chatWindow.scrollHeight;
    chatWindow.scrollTo(0, xH);
  }, [chatHistory]);

  React.useEffect(() => {
    setStagePercentageState();
  }, [profileData]);
  //3. Send answer
  const handleSendAnswer = (answer) => {
    const newChatHistory = [
      ...chatHistory,
      {
        type: "receive",
        message: questions[currentQuestionIndex].title,
      },
      {
        type: "send",
        message: answer,
        name: questions[currentQuestionIndex].name,
      },
    ];
    if (questions[currentQuestionIndex].name === "email") {
      const email = answer.trim();
      handleSendLoginToken(email, newChatHistory);
    } else if (questions[currentQuestionIndex].name === "password") {
      // const email = chatHistory
      //   .find((chat) => chat.name === "email")
      //   .message.trim();
      const password = answer.trim();
      handleVerifyLoginOTP(password, newChatHistory);
      // handleSignIn(email, password, newChatHistory);
    } else if (questions[currentQuestionIndex].name === "parent_email") {
      const email = answer.trim();
      handleSendParentLoginToken(email, newChatHistory);
    } else if (questions[currentQuestionIndex].name === "parent_password") {
      // const email = chatHistory
      //   .find((chat) => chat.name === "email")
      //   .message.trim();
      const password = answer.trim();
      handleVerifyParentLoginOTP(password, newChatHistory);
      // handleSignIn(email, password, newChatHistory);
    } else if (questions[currentQuestionIndex].name === "date_of_birth") {
      handleBasicInfoUpdate(newChatHistory);
    } else {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setChatHistory(newChatHistory);
      localStorage.setItem("chatHistory", JSON.stringify(newChatHistory));
    }
  };
  // 4. Render UI methods
  const renderCorrectQuestion = (question) => {
    switch (question.type) {
      case "input":
        return (
          <InputQuestion
            handleSendAnswer={handleSendAnswer}
            question={question}
          />
        );
      case "radio":
        return (
          <RadioQuestion
            handleSendAnswer={handleSendAnswer}
            question={question}
          />
        );
      case "date":
        return (
          <DateQuestion
            handleSendAnswer={handleSendAnswer}
            question={question}
          />
        );
      case "photo":
        return (
          <PhotoQuestion
            handleSendAnswer={handleSendAnswer}
            question={question}
          />
        );
      default:
        return null;
    }
  };
  const renderCurrentQuestion = (question) => {
    if (currentQuestionIndex >= questions.length) return null;
    const currentQuestion = questions[currentQuestionIndex];
    return (
      <div className={styles.CurrentQuestion + " " + styles.receive}>
        <p
          style={
            currentQuestion && currentQuestion.type === "info-success"
              ? { color: "#198754" }
              : null
          }
        >
          {currentQuestion.title}
        </p>
        {renderCorrectQuestion(currentQuestion)}
      </div>
    );
  };

  const renderChatHistory = () => {
    return chatHistory.map((chat, i) => (
      <div className={styles[chat.type]} key={i}>
        {chat.name === "take_photo" ? (
          <img src={chat.message} alt="verification" />
        ) : (
          <p>
            {chat.message}
            {/* {chat.type === "send" && chat.name.includes("password")
              ? "*".repeat(chat.message.length)
              : chat.message} */}
          </p>
        )}
      </div>
    ));
  };
  //5. Apis: 7 calls

  const handleSendLoginToken = (email, newChatHistory) => {
    // const url = "https://idverification.masaischool.com/api/login";
    const url = `${baseUrl}/login`;
    setLoading(true);
    axios
      .post(url, { email })
      .then((response) => {
        localStorage.setItem("userId", response.data.data.id);
        // localStorage.setItem("token", response.data.data.token);
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setChatHistory(newChatHistory);
        localStorage.setItem("isLoginTokenSent", JSON.stringify(true));
        localStorage.setItem("chatHistory", JSON.stringify(newChatHistory));
        setIsLoginTokenSent(true);
        toast.success("Login OTP sent successfully to your email!");
        // hanldleGetProfile();
      })
      .catch((error) => {
        setChatHistory([]);
        localStorage.setItem("chatHistory", JSON.stringify([]));
        setCurrentQuestionIndex(0);
        toast.error(error.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleVerifyLoginOTP = (loginOTP, newChatHistory) => {
    // const url = "https://idverification.masaischool.com/api/login";
    const userId = localStorage.getItem("userId");
    const url = `${baseUrl}/verify_token/${userId}`;

    setLoading(true);
    axios
      .post(url, null, {
        params: { token: loginOTP },
      })
      .then((response) => {
        // localStorage.setItem("userId", response.data.data.id);
        localStorage.setItem("token", loginOTP);
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setChatHistory(newChatHistory);
        localStorage.setItem("chatHistory", JSON.stringify(newChatHistory));
        setIsLoggedIn(true);
        toast.success("Sign In Successful!");
        hanldleGetProfile();
      })
      .catch((error) => {
        setChatHistory([]);
        localStorage.setItem("chatHistory", JSON.stringify([]));
        setCurrentQuestionIndex(0);
        toast.error(error.response.data.message + " , Please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // handle personal email and otp

  // handle parent email and otp
  const handleSendParentLoginToken = (email, newChatHistory) => {
    // const url = "https://idverification.masaischool.com/api/login";
    const userId = localStorage.getItem("userId");
    const url = `${baseUrl}/send_token/parent/${userId}`;
    setLoading(true);
    axios
      .post(url, { email })
      .then((response) => {
        // localStorage.setItem("userId", response.data.data.id);
        // localStorage.setItem("token", response.data.data.token);
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setChatHistory(newChatHistory);
        localStorage.setItem("isParentLoginTokenSent", JSON.stringify(true));
        localStorage.setItem("chatHistory", JSON.stringify(newChatHistory));
        // setIsLoginTokenSent(true);
        toast.success("OTP sent successfully to your parent email!");
        // hanldleGetProfile();
      })
      .catch((error) => {
        setChatHistory([]);
        localStorage.setItem("chatHistory", JSON.stringify([]));
        setCurrentQuestionIndex(2);
        toast.error(error.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleVerifyParentLoginOTP = (loginOTP, newChatHistory) => {
    // const url = "https://idverification.masaischool.com/api/login";
    const userId = localStorage.getItem("userId");
    const url = `${baseUrl}/verify_token/parent/${userId}`;
    setLoading(true);
    axios
      .post(url, null, {
        params: { token: loginOTP },
      })
      .then((response) => {
        // localStorage.setItem("userId", response.data.data.id);
        // localStorage.setItem("parentToken", loginOTP);
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setChatHistory(newChatHistory);
        localStorage.setItem("chatHistory", JSON.stringify(newChatHistory));
        toast.success("Parent Email verification successful!");
        hanldleGetProfile();
      })
      .catch((error) => {
        setChatHistory([]);
        localStorage.setItem("chatHistory", JSON.stringify([]));
        setCurrentQuestionIndex(2);
        toast.error(error.response.data.message + " , Please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleBasicInfoUpdate = (newChatHistory) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    const url = `${baseUrl}/profile/${userId}`;
    setLoading(true);
    const name = newChatHistory
      .find((chat) => chat.name === "name")
      .message.trim();
    console.log(name);
    const parent_name = newChatHistory
      .find((chat) => chat.name === "parent_name")
      .message.trim();
    console.log(parent_name);
    const student_phone = newChatHistory
      .find((chat) => chat.name === "student_phone")
      .message.trim();
    console.log(student_phone);
    const self_filled_student_code = newChatHistory
      .find((chat) => chat.name === "self_filled_student_code")
      .message.trim();
    console.log(self_filled_student_code);
    const dob = newChatHistory
      .find((chat) => chat.name === "date_of_birth")
      .message.trim();
    console.log(dob);
    axios
      .patch(
        url,
        {
          name,
          parent_name,
          student_phone,
          dob,
          self_filled_student_code,
        },
        {
          params: {
            token,
          },
        }
      )
      .then((response) => {
        hanldleGetProfile();
        setCurrentQuestionIndex(questions.length - 1);
        setChatHistory(newChatHistory);
        localStorage.setItem("chatHistory", JSON.stringify(newChatHistory));
        setIsBasicInfoVerified(true);
        localStorage.setItem("isBasicInfoVerified", JSON.stringify(true));
        toast.success("Information Received Successfully");
      })
      .catch((error) => {
        setCurrentQuestionIndex(4);
        toast.error(error.response.data.message + " , Please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const hanldleGetProfile = () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    const url = `${baseUrl}/profile/${userId}`;
    setLoading(true);
    axios
      .get(url, {
        params: {
          token,
        },
      })
      .then((response) => {
        setProfile(response.data.data);
        toast.success("User profile fetch successfully!");
      })
      .catch((error) => {
        toast.error(error.response.data.message + " , Please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSignOut = () => {
    localStorage.clear();
    setStagePercentage(0);
    setIsLoggedIn(false);
    setCurrentQuestionIndex(0);
    setChatHistory([]);
    setIsImageVerified(null);
    setIsOtpVerified(null);
    setIsBasicInfoVerified(null);
  };

  const handleResetChat = () => {
    if (!isLoggedIn) {
      setCurrentQuestionIndex(0);
      localStorage.clear();
      setChatHistory([]);
      setIsImageVerified(null);
      setIsOtpVerified(null);
      setIsBasicInfoVerified(null);
      return;
    }
    setCurrentQuestionIndex(2);
    setChatHistory([]);
    setIsImageVerified(null);
    setIsOtpVerified(null);
    setIsBasicInfoVerified(null);
    localStorage.removeItem("chatHistory");
    localStorage.removeItem("isOtpVerified");
    localStorage.removeItem("isImageVerified");
    localStorage.removeItem("isBasicInfoVerified");
  };
  const setStagePercentageState = () => {
    if (!profileData) return 0;
    switch (profileData.stage_data) {
      case "LOGGED_IN":
        return setStagePercentage(50);
      case "PROFILE_FILLED":
        return setStagePercentage(100);
      default:
        return 0;
    }
  };

  //6. JSX
  return (
    <>
      <div className={styles.ChatBox}>
        {!isBasicInfoVerified && (
          <div className={styles.buttons}>
            <button
              disabled={isBasicInfoVerified}
              className={styles.SignOut}
              onClick={handleSignOut}
            >
              Reset Chat
            </button>
          </div>
        )}

        <div id="chat-window" className={styles.ChatBox__messages}>
          <div className={styles.ChatHistory}>{renderChatHistory()}</div>
          {renderCurrentQuestion()}
        </div>
        <LoadingOverlay
          active={loading}
          spinner
          text="Please wait..."
        ></LoadingOverlay>
      </div>
    </>
  );
};

export default ChatBox;
